import { IAnimationElementProps } from '../../../../../common/Animation';

export const layoutAnimationConfig: IAnimationElementProps = {
  initial: { opacity: 0, scale: 0 },
  animate: { opacity: 1, scale: 1 },
  exit: { opacity: 0, scale: 0 },
  transition: { type: 'spring', duration: 0.7 },
};
